import styled from "styled-components";

export const UiModalTitle = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	color: #1890ff;
`;

export const StyledUpdateRemark = styled.div`
	.hint {
		margin-bottom: 12px;
		color: #333;

		> span {
			font-weight: 700;
			color: #ff4d4f;
		}
	}
`;
